import * as React from 'react';

var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _rect, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var SvgEarninline = function SvgEarninline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 61,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.875 44.758h-7.5",
    stroke: "#001E62",
    strokeWidth: 0.667,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.201 38.333a6.787 6.787 0 0 0 7.44-.692l1.077-.861a6.795 6.795 0 0 1 8.5.006 6.784 6.784 0 0 0 7.835.474l3.572-2.249s-.15-4.373-3.133-7.904c0 0-8.424-9.529-19.576 2.422 0 0-.94 5.818-4.613 2.4 0 0-3.696 2.448-6.428 1.938l.15 1.762c0 .186 5.176 2.701 5.176 2.701v.003Z",
    fill: "#D6CF8D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.054 40.623c.275 3.08-.304 5.372-.785 6.67a1.877 1.877 0 0 1-1.762 1.215h-1.219c-1.034 0-1.875-.827-1.875-1.845v-1.282c0-1.176-.97-2.13-2.166-2.13a6.379 6.379 0 0 1-4.047-1.444l-.543-.446c-.718-.591-1.273-1.345-1.674-2.175a2.333 2.333 0 0 0-2.108-1.31V33.9h1.148c2.15 0 4.16-1.024 5.401-2.735 0 0 1.578-3.709.317-4.45-1.516-.894-1.975 5.782 1.26 6.317 3.094.512 4.032-4.345.511-6.097",
    stroke: "#001E62",
    strokeWidth: 0.667,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.25 35.383c.68.833 1.82.833 2.5 0",
    stroke: "#001E62",
    strokeWidth: 0.667,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.25 25.724c.84-.224 1.722-.341 2.635-.341h.552c.846 0 1.665.122 2.438.352l-.343.898a6.714 6.714 0 0 0-2.14-.352h-.486c-.8 0-1.573.12-2.313.34l-.343-.897Z",
    fill: "#fff",
    stroke: "#001E62",
    strokeWidth: 0.667,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M54.625 34.758c0-6.214-5.155-11.25-11.511-11.25a11.61 11.61 0 0 0-8.073 3.23c-.755.725-1.507 1.452-2.291 2.14M46.5 40.631v6.068c0 .998.806 1.809 1.798 1.809.425 0 .834-.15 1.16-.428.446-.377.976-1.85 1.494-3.331.66-1.89 1.503-3.54 2.244-5.51.177-.467.639-1.465.853-2.036.344-.5 1.113-.584 1.615-.25.353.234.577.618.893.895.387.34.927.512 1.429.397.502-.116.933-.537 1.004-1.049.072-.511-.26-1.063-.76-1.188",
    stroke: "#001E62",
    strokeWidth: 0.667,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M43.005 16.008h-.08c-.44.53-1.18.9-1.202 1.613-.027 1.014 1.478 1.553 1.319 2.553-.101.62-.771.867-1.224 1.257-.122.107-.226.23-.318.363.438.294.952.464 1.505.464 1.585 0 2.87-1.4 2.87-3.127 0-1.727-1.282-3.123-2.87-3.123Z",
    fill: "#D6CF8D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M42.75 17.258c1.036 0 1.875.839 1.875 1.875",
    stroke: "#001E62",
    strokeWidth: 0.667,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M43.063 22.258c1.553 0 2.812-1.4 2.812-3.125 0-1.726-1.26-3.125-2.813-3.125-1.553 0-2.812 1.399-2.812 3.125s1.26 3.125 2.813 3.125Z",
    stroke: "#001E62",
    strokeWidth: 0.667,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.133,
    width: 30,
    height: 30,
    rx: 15,
    fill: "#E6F9FA"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M18.288 21.133h-7.344v-2.048L14 16.22c.79-.747 1.36-1.408 1.712-1.984.352-.576.528-1.136.528-1.68 0-.566-.155-1.008-.464-1.328-.277-.299-.65-.448-1.12-.448-.939 0-1.525.586-1.76 1.76h-2c.341-2.315 1.595-3.472 3.76-3.472 1.173 0 2.09.304 2.752.912.63.587.944 1.392.944 2.416 0 1.525-.683 2.933-2.048 4.224l-2.656 2.496h4.64v2.016Z",
    fill: "#2F7B84"
  })));
};
var EarnIcon = SvgEarninline;

export { EarnIcon as default };
//# sourceMappingURL=earn.inline.svg.js.map
